import React from 'react'
import { ofType } from 'redux-observable'
import { map } from 'rxjs/operators'
import { createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { replace } from 'connected-react-router'
import { RequestVideoAccess, WS } from './videocallSlice'
import { addModal } from '../modals/modalSlice'
import ReceiveAccessRequest from './components/ReceiveAccessRequest'
import { ReceivedFromUserPayload } from '../websocket/sendToUser'
import { RootState } from '../../store'
import getCurrentRoute from '../../utils/getCurrentRoute'
import { ParamSlug } from '../../types'
import routes from '../../routes'
import { showNotification } from '../notifications'
import { _ } from '../../utils/localization'
import { setGotKicked } from '../meetings/currentMeetingSlice'

const pipeAccessRequestsToModal = (action$) => action$.pipe(
    ofType(WS.accessRequested.type),
    map((accessRequest: PayloadAction<RequestVideoAccess>) => {
        if (accessRequest.payload.show_in_modal) {
            const Component = ({ close }: { close: () => void }) => (
                <ReceiveAccessRequest close={close} accessRequest={accessRequest.payload} />
            )
            return addModal({
                Component,
                size: 'sm',
                padding: 0,
                backdrop: 'static'
            })
        }
        return () => null
    }),
)

const handleGotKicked = createAsyncThunk(
    'HANDLE_GOT_KICKED',
    (sender: number, thunkAPI) => {
        const state = thunkAPI.getState() as RootState
        const videocall = state.videocall?.current

        if (!videocall) {
            return
        }

        if (sender !== videocall?.admin_id) {
            return
        }

        thunkAPI.dispatch(setGotKicked(true))

        const route = getCurrentRoute(state.router.location.pathname)
        const params = route && route.params as ParamSlug
        const path = params.meetingSlug
            ? routes.meeting.getPath(params)
            : `/${params.eventSlug}/`

        thunkAPI.dispatch(replace(path))
        thunkAPI.dispatch(showNotification({
            type: 'warning',
            body: _('videocall.you_got_kicked'),
        }))
    }
)

const pipeGotKicked = (action$) => action$.pipe(
    ofType(WS.gotKicked.type),
    map((action: PayloadAction<ReceivedFromUserPayload<null>>) => handleGotKicked(action.payload.sender)),
)

export default [pipeAccessRequestsToModal, pipeGotKicked]
